import React from "react";
import { Col } from "antd";
import eleapLogo from "../../../../../../assets/images/eleap-logo-dark.svg";
import {useTranslation} from "react-i18next";

// Styles
import './style/external_surveys_success.scss';

const ExternalSurveysSuccess = ({
    surveyId,
}) => {
    const { t } = useTranslation();

    return(
        <div className='surveys_success'>
            <div className='modal_container modal'>
                <Col span={24}>
                    <div className='surveys_success-wrapper'>
                        <div className="surveys_success_header">
                            <div className='surveys_success_title'>
                                <h2>Thank You for Your Participation</h2>
                                <div className='surveys_success_subtitle'>
                                    <h3>Your response has been successfully submitted.</h3>
                                    <div className="success-survey_logo">
                                        <span className="text">{t("Powered by")}</span>
                                        <a className="success-survey_logo-link" href="https://performance.eleapsoftware.com" target="_blank">
                                            <img loading="lazy" src={eleapLogo} alt="logo" width="60" height="32.73" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='surveys_success-content'>
                            <p>
                                We appreciate the time you've taken to complete this survey.
                                Your feedback is valuable and will help us make informed decisions that benefit our communities.
                            </p>
                            <h4>What happens next?</h4>
                            <ul>
                                <li>
                                    <span>Your responses are secure: </span>
                                    All data is stored safely and will be handled in accordance with our privacy policy
                                </li>
                                <li>
                                    <span>Analysis in progress: </span>
                                    Our team will carefully review and analyze all responses
                                </li>
                                <li>
                                    <span>Results sharing: </span>
                                    If applicable, summary results may be shared with participants once the survey period concludes
                                </li>
                            </ul>
                            <h4>Need assistance?</h4>
                            <p>
                                If you have any questions about this survey or encounter any technical issues, please don't hesitate to contact our support team.
                            </p>
                            <h4>Contact Information:</h4>
                            <ul>
                                <li>
                                    <span>Email: </span>
                                    support@eleapsoftware.com
                                </li>
                                <li>
                                    <span>Phone: </span>
                                    877-624-7226
                                </li>
                            </ul>
                            <h4>Stay connected</h4>
                            <p>
                                For updates about this survey or future opportunities to provide feedback, please check your email or visit our site <a href="https://performance.eleapsoftware.com">https://performance.eleapsoftware.com</a>.
                            </p>
                        </div>
                        <div className='surveys_success_footer'>
                            <p>
                                <span>Powered by </span>
                                <a href="https://performance.eleapsoftware.com">eLeaP Performance Management Platform</a>
                            </p>
                            <p>
                                This survey is part of our commitment to continuous improvement and organizational excellence.
                            </p>
                            <h4>Survey Reference</h4>
                            <ol>
                                <li>
                                    <span>Survey ID: </span>
                                    {surveyId}
                                </li>
                                <li>
                                    <span>Submission Date: </span>
                                    {new Date().toLocaleDateString()}
                                </li>
                                <li>
                                    <span>Completion Status: </span>
                                    ✅ Complete
                                </li>
                            </ol>
                            <p>
                                You may now safely close this window.
                            </p>
                        </div>
                    </div>
                </Col>
            </div>
        </div>
    )
}
export default ExternalSurveysSuccess;